import { ComponentType as s } from "../../registries/types/propTypes.js";
import { transformContentCardCommonData as p } from "../article-card-transformer/article-card-transformer.js";
const c = (e) => {
  var o, n, i;
  const l = p(e);
  let r = {};
  if (e) {
    const m = {
      text: (o = e == null ? void 0 : e.link) == null ? void 0 : o.text,
      url: (n = e == null ? void 0 : e.link) == null ? void 0 : n.url,
      target: (i = e == null ? void 0 : e.link) == null ? void 0 : i.target
    };
    r = {
      subTitle: e == null ? void 0 : e.sub_title,
      resourceType: e == null ? void 0 : e.file_type,
      detailPage: e == null ? void 0 : e.detail_page,
      link: m
    };
  }
  return {
    componentType: s.resource_card,
    ...l,
    ...r
  };
};
export {
  c as default
};
//# sourceMappingURL=resource-card-transformer.js.map
